export enum AgentMode {
    Agent = "agent",
    Spec = "spec",
    Ralph = "ralph",
}

export function cycleAgentMode(current: AgentMode, availableModes: AgentMode[]): AgentMode {
    const currentIndex = availableModes.indexOf(current);
    if (currentIndex === -1) {
        return availableModes[0];
    }
    const nextIndex = (currentIndex + 1) % availableModes.length;
    return availableModes[nextIndex];
}

const RALPH_COMMAND_PREFIX = "/ona:ralph";
const SPEC_COMMAND_PREFIX = "/ona:spec";

/**
 * Applies the agent mode prefix to a prompt based on the selected mode.
 */
export function applyAgentModePrefix(prompt: string, agentMode: AgentMode): string {
    if (agentMode === AgentMode.Ralph) {
        return `${RALPH_COMMAND_PREFIX} ${prompt}`;
    }
    if (agentMode === AgentMode.Spec) {
        return `${SPEC_COMMAND_PREFIX} ${prompt}`;
    }
    return prompt;
}

/**
 * Returns the display label for an agent mode.
 */
export function getAgentModeLabel(mode: AgentMode): string {
    switch (mode) {
        case AgentMode.Ralph:
            return "Ralph";
        case AgentMode.Spec:
            return "Spec";
        case AgentMode.Agent:
        default:
            return "Agent";
    }
}
